import { Component, OnInit, Input } from '@angular/core';
import { SessionService } from '../shared/services/session/session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'vit-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss']
})
export class HeaderBarComponent implements OnInit {

  @Input() showHits = true;
  @Input() showBack = false;

  constructor(public sessionService: SessionService,
              public router: Router) {
  }

  ngOnInit() {
  }

  navigateToGameView() {
    this.router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/header-bar/header-bar.component.ts